/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-event
 * OpenAPI spec version: 1.0.0
 */
import type {
  AbacusEventResponse,
  AbacusEventsResponse,
  CreateAbacusEventBody,
  CreateAbacusEventHeaders,
  DataloadAbacusEventsHeaders,
  DataloadAbacusEventsResponse,
  GetAbacusEventHeaders,
  GetAbacusEventPathParameters,
  GetAbacusEventsBody,
  GetAbacusEventsByTargetHeaders,
  GetAbacusEventsByTargetPathParameters,
  GetHealthHeaders,
  GetPaymentGroupPaymentApprovalCountHeaders,
  GetPaymentGroupPaymentApprovalCountPathParameters,
  HealthResponse,
  PaymentGroupPaymentApprovalCountResponse,
  RollbackAbacusEventBody,
  RollbackAbacusEventHeaders,
} from "./types";
/**
 * Create an Abacus event
 */
export const getCreateAbacusEventUrl = () => {
  return `/abacus-event/`;
};
/**
 * Get an Abacus event by ID
 */
export const getGetAbacusEventUrl = ({
  abacusEventId,
}: GetAbacusEventPathParameters) => {
  return `/abacus-event/${abacusEventId}`;
};
/**
 * Get all events for a specified target type / id
 */
export const getGetAbacusEventsByTargetUrl = ({
  targetType,
  targetId,
}: GetAbacusEventsByTargetPathParameters) => {
  return `/abacus-event/${targetType}/${targetId}/`;
};
/**
 * Dataload Abacus events by Abacus event IDs
 */
export const getDataloadAbacusEventsUrl = () => {
  return `/abacus-event/dataloader`;
};
/**
 * Get the number of current approval events for a Payment Group Payment
 */
export const getGetPaymentGroupPaymentApprovalCountUrl = ({
  paymentGroupPaymentId,
}: GetPaymentGroupPaymentApprovalCountPathParameters) => {
  return `/abacus-event/payment-group-payment/${paymentGroupPaymentId}/approval-count/`;
};
/**
 * @summary Rolls back an Abacus event
 */
export const getRollbackAbacusEventUrl = () => {
  return `/abacus-event/rollback/`;
};
/**
 * Check the health of the application.
 */
export const getGetHealthUrl = () => {
  return `/hello/`;
};
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
import { type Logger, type HeaderProvider } from "@abacus/common";

import { type Throttler } from "@abacus/throttlers";

import { ApiResponse } from "./common";

export interface ApiConfig {
  auth?: HeaderProvider;
  baseUrl?: string;
  logger?: Logger;
  throttler?: Throttler;
}

export class OwsAbacusEventClient {
  auth?: HeaderProvider;
  baseUrl: string;
  logger?: Logger;
  throttler?: Throttler;

  constructor(config?: ApiConfig) {
    this.auth = config?.auth;
    this.baseUrl = config?.baseUrl ?? `https://localhost:8080`;
    this.logger = config?.logger;
    this.throttler = config?.throttler;
  }

  async _fetch<T>(url: string, options: RequestInit): Promise<ApiResponse<T>> {
    // On request
    url = await this._onRequest(url, options);
    // Make request
    const response = await fetch(url, options);
    // Get data
    const data = await this._getData<T>(response);
    const headers = Object.fromEntries(response.headers.entries());
    // Return response
    return { data, headers, status: response.status };
  }

  private _getData<T>(res: Response): Promise<T> {
    const contentType = res.headers.get("content-type");
    if (contentType) {
      if (contentType.includes("application/json")) {
        return res.json() as Promise<T>;
      }
      if (contentType && contentType.includes("application/pdf")) {
        return res.blob() as Promise<T>;
      }
    }
    return res.text() as Promise<T>;
  }

  private async _getHeaders(
    headers?: Record<string, string>,
  ): Promise<Record<string, string>> {
    return {
      ...(await this.auth?.getHeaders()),
      ...headers,
    };
  }

  private async _onRequest(url: string, options: RequestInit): Promise<string> {
    // Throttle the request
    await this.throttler?.wait();
    // Get URL
    url = url = `${this.baseUrl}${url}`;
    // Add Headers
    const headers = options.headers as Record<string, string>;
    options.headers = await this._getHeaders(headers);
    // Log the request
    this.logger?.debug(`Requesting ${options.method} ${url}`);
    return url;
  }

  async createAbacusEvent(
    createAbacusEventBody: CreateAbacusEventBody,
    headers?: CreateAbacusEventHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusEventResponse>(getCreateAbacusEventUrl(), {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...headers,
          ...options?.headers,
        },
        body: JSON.stringify(createAbacusEventBody),
      });
    }
  }

  async getAbacusEvent(
    { abacusEventId }: GetAbacusEventPathParameters,
    headers?: GetAbacusEventHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusEventResponse>(
        getGetAbacusEventUrl({ abacusEventId }),
        {
          ...options,
          method: "GET",
          headers: { ...headers, ...options?.headers },
        },
      );
    }
  }

  async getAbacusEventsByTarget(
    { targetType, targetId }: GetAbacusEventsByTargetPathParameters,
    headers?: GetAbacusEventsByTargetHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusEventsResponse>(
        getGetAbacusEventsByTargetUrl({ targetType, targetId }),
        {
          ...options,
          method: "GET",
          headers: { ...headers, ...options?.headers },
        },
      );
    }
  }

  async dataloadAbacusEvents(
    getAbacusEventsBody: GetAbacusEventsBody,
    headers?: DataloadAbacusEventsHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<DataloadAbacusEventsResponse>(
        getDataloadAbacusEventsUrl(),
        {
          ...options,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers,
            ...options?.headers,
          },
          body: JSON.stringify(getAbacusEventsBody),
        },
      );
    }
  }

  async getPaymentGroupPaymentApprovalCount(
    {
      paymentGroupPaymentId,
    }: GetPaymentGroupPaymentApprovalCountPathParameters,
    headers?: GetPaymentGroupPaymentApprovalCountHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<PaymentGroupPaymentApprovalCountResponse>(
        getGetPaymentGroupPaymentApprovalCountUrl({ paymentGroupPaymentId }),
        {
          ...options,
          method: "GET",
          headers: { ...headers, ...options?.headers },
        },
      );
    }
  }

  async rollbackAbacusEvent(
    rollbackAbacusEventBody: RollbackAbacusEventBody,
    headers?: RollbackAbacusEventHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusEventResponse>(getRollbackAbacusEventUrl(), {
        ...options,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...headers,
          ...options?.headers,
        },
        body: JSON.stringify(rollbackAbacusEventBody),
      });
    }
  }

  async getHealth(headers?: GetHealthHeaders, options?: RequestInit) {
    {
      return this._fetch<HealthResponse>(getGetHealthUrl(), {
        ...options,
        method: "GET",
        headers: { ...headers, ...options?.headers },
      });
    }
  }
}
